import Vue from 'vue';
import Vuex from 'vuex';
import { UserModule } from '@/store/modules/User/user.module.js';
import { ProductsModule } from '@/store/modules/Products/products.module.js';
import { AddressModule } from '@/store/modules/Address/address.module.js';
import { OrderModule } from '@/store/modules/Order/order.module.js';
import { OrganizationModule } from '@/store/modules/Organization/organization.module.js';
import { CartModule } from '@/store/modules/Cart/cart.module.js';
Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        UserModule,
        ProductsModule,
        AddressModule,
        OrderModule,
        OrganizationModule,
        CartModule,
    },
});

export { store };
